import { render, staticRenderFns } from "./ProductBottomSheetVd3List.vue?vue&type=template&id=18fec742&"
import script from "./ProductBottomSheetVd3List.vue?vue&type=script&lang=js&"
export * from "./ProductBottomSheetVd3List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBottomNavigation,VBottomSheet,VBtn})
